import { PreloadedQuery } from 'react-relay';

import { createPlatformSiteAri } from '@townsquare/collab-context/create-site-ari';
import { createRelayResource, RelayResourceConfig } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
	RouteResource,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import RovoCleanUpTeamsNudgeAggQuery, {
	type AggRovoCleanUpTeamsNudgeAggQuery as RovoCleanUpTeamsNudgeAggQueryType,
} from '../components/__generated__/AggRovoCleanUpTeamsNudgeAggQuery.graphql';

const getCleanUpTeamsSkillNudgeResourceQuery = (
	_routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<RovoCleanUpTeamsNudgeAggQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const accountId = context.user.accountId;
	const isOrgAdmin = context.workspace?.capabilities?.orgAdmin ?? false;

	const userTeamQuery = isOrgAdmin
		? `(isVerifiedTeamFilter != 'true')`
		: `(member = ${accountId}) AND (isVerifiedTeamFilter != 'true')`;

	const siteId = context.collabContext?.rovoWorkspace || context.workspace?.cloudId || '';
	const scopeId = createPlatformSiteAri(siteId) ?? '';

	const isCleanUpTeamsRovoSkillEnabled = fg('enable_clean_up_teams_agentic_skill');

	return {
		environment: getAggRelayEnvironment(),
		query: RovoCleanUpTeamsNudgeAggQuery,
		variables: {
			scopeId,
			userTeamQuery,
			isCleanUpTeamsRovoSkillEnabled,
		},
		options: {
			fetchPolicy: 'store-or-network',
		},
	};
};

export const cleanUpTeamsSkillNudgeResource: RouteResource<
	PreloadedQuery<RovoCleanUpTeamsNudgeAggQueryType, Record<string, unknown>>
> = createRelayResource<RovoCleanUpTeamsNudgeAggQueryType>({
	getQuery: getCleanUpTeamsSkillNudgeResourceQuery,
});
